import { setSeconds } from "date-fns";
import { useEffect, useState } from "react";
import {
  upload_multiple_image,
  get_variants,
  delete_variant,
} from "../../reduxData/user/userAction";
import * as Yup from "yup";
import { print_order_detail } from "../../reduxData/user/userAction";

export const initialValues = (type, data) => {
  return {
    title: type == "edit" ? data?.title : "",
    article_number: type == "edit" ? data?.article_number : "",
    description: type == "edit" ? data?.description : "",
    brand_id: type == "edit" ? data?.brand_id : "",
    category_id: type == "edit" ? data?.category_id : "",
    original_retail_price: type == "edit" ? data?.original_retail_price : "",
    images: type === "edit" && Array.isArray(data?.images) ? data.images : [],
    product_type_id: type == "edit" && data?.product_type ? data?.product_type : "",
  };
};

export const schema = Yup.object({
  title: Yup.string().required("Title is required"),
  article_number: Yup.string().required("Article number is required"),
  description: Yup.string().required("Description is required"),
  brand_id: Yup.number().required("Brand name is required"),
  category_id: Yup.number().required("Category is required"),
  product_type_id: Yup.number().required("Type is required"),

  original_retail_price: Yup.number().positive("Price must be positive"),
  // .required("Price is required")
  images: Yup.array()
    .of(Yup.string())
    .min(1, "Atleast one is required")
    .required("At least one image is required"),
});

export const useDebounce = (value, time) => {
  const [search, setSearch] = useState(value);
  useEffect(() => {
    let timer = setTimeout(() => {
      setSearch(value);
    }, time);
    return () => {
      clearTimeout(timer);
    };
  }, [value]);

  return search;
};

export const handleImageUpload = async (
  e,
  colorId,
  setColorImages,
  colorImages
) => {
  const files = e.target.files;
  if (!files || files.length === 0) return;

  const formData = new FormData();
  for (const file of files) {
    formData.append("images", file);
  }

  try {
    const res = await upload_multiple_image(
      formData,
      localStorage.getItem("token")
    );

    setColorImages((prev) => ({
      ...prev,
      [colorId]: res?.data?.data,
    }));
  } catch (error) {
    console.error("Upload error:", error);
  }
};

export const handleVariantImageUpload = async (
  e,
  combinationKey,
  setCombinationImages,
  combinationImages
) => {
  const files = e.target.files;
  if (!files || files.length === 0) return;

  const formData = new FormData();
  for (const file of files) {
    formData.append("images", file);
  }

  try {
    const res = await upload_multiple_image(
      formData,
      localStorage.getItem("token")
    );

    console.log("response of the images api", res?.data?.data);

    setCombinationImages((prev) => ({
      ...prev,
      [combinationKey]: res?.data?.data || [],
    }));
  } catch (error) {
    console.error("Upload error:", error);
  }
};

export const useVariantsList = (token, id, status) => {
  const [list, setList] = useState([]);
  const [tableFields, setTableFields] = useState([]);
  const [uniqueList, setUniqueVariants] = useState([]);
  const [uniqueAttributeValues, setUniqueAttributeValues] = useState([]);

  const fetchData = async () => {
    try {
      const res = await get_variants(token, id, status);
      if (res) {
        console.log(
          "res filtering ",
          res?.data?.filter((i) => i?.isdeleted == "false"),
          res?.data
        );
        setList(res?.data || []);
        setUniqueVariants(res?.data || []);
        const uniqueAttributes = [];
        const seenAttributeIds = new Set();

        // Map to store attribute values: attribute_id -> Set of unique values
        const attributeValuesMap = new Map();

        res?.data?.forEach((variant) => {
          variant?.attributes?.forEach((attr) => {
            if (
              attr?.attribute_value_id !== null &&
              !seenAttributeIds.has(attr.attribute_id)
            ) {
              uniqueAttributes.push({
                attribute_id: attr.attribute_id,
                attribute_name: attr.attribute_name,
              });
              seenAttributeIds.add(attr.attribute_id);
            }

            // Extract attribute values with their IDs
            if (
              attr?.attribute_id &&
              attr?.attribute_value_id !== null &&
              attr?.value
            ) {
              if (!attributeValuesMap.has(attr.attribute_id)) {
                attributeValuesMap.set(attr.attribute_id, {
                  attribute_id: attr.attribute_id,
                  attribute_name: attr.attribute_name,
                  values: new Map(), // Use Map to store unique values by value_id
                });
              }

              const attrData = attributeValuesMap.get(attr.attribute_id);
              // Store unique values by attribute_value_id to avoid duplicates
              if (!attrData.values.has(attr.attribute_value_id)) {
                attrData.values.set(attr.attribute_value_id, {
                  id: attr.attribute_value_id,
                  value: attr.value,
                });
              }
            }
          });
        });

        // Convert Map to array format
        const extractedAttributeValues = Array.from(
          attributeValuesMap.values()
        ).map((attrData) => ({
          attribute_id: attrData.attribute_id,
          attribute_name: attrData.attribute_name,
          values: Array.from(attrData.values.values()),
        }));

        console.log(
          "📊 Extracted Preselected Attribute Values:",
          extractedAttributeValues
        );
        setUniqueAttributeValues(extractedAttributeValues);
        setTableFields(uniqueAttributes);
      }
    } catch (error) {
      console.error("Error fetching variants:", error);
    }
  };

  const handleDeleteVariant = async (variant_id) => {
    try {
      const res = await delete_variant(token, variant_id);
      if (res) {
        fetchData();
      }
    } catch (error) {
      console.error("Error deleting variant:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return {
    list,
    handleDeleteVariant,
    fetchData,
    tableFields,
    setTableFields,
    uniqueList,
    uniqueAttributeValues,
    setList,
  };
};

export const handleDate = (i) => {
  const date = new Date(i);
  const formatDate = date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  return formatDate;
};

export const ApprovalModal = ({
  show,
  onClose,
  onConfirm,
  currentStatus,
  productTitle,
}) => {
  const [selectedStatus, setSelectedStatus] = useState("");
  const [reason, setReason] = useState("");

  useEffect(() => {
    setSelectedStatus(currentStatus);
    setReason("");
  }, [currentStatus, show]);

  if (!show) return null;

  return (
    <div
      className="modal fade show"
      style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
      onClick={onClose}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Update Product Status</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>

          <div className="modal-body">
            <div className="mb-3">
              <label className="form-label fw-semibold">
                Product: {productTitle}
              </label>
            </div>
            <div className="mb-3">
              <label className="form-label fw-semibold">Select Status</label>
              <div className="d-flex gap-3">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="status"
                    id="approved"
                    value="approved"
                    checked={selectedStatus === "approved"}
                    onChange={(e) => setSelectedStatus(e.target.value)}
                  />
                  <label className="form-check-label" htmlFor="approved">
                    <i className="bi bi-check-circle text-success me-1"></i>
                    Approve
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="status"
                    id="rejected"
                    value="rejected"
                    checked={selectedStatus === "rejected"}
                    onChange={(e) => setSelectedStatus(e.target.value)}
                  />
                  <label className="form-check-label" htmlFor="rejected">
                    <i className="bi bi-x-circle text-danger me-1"></i>
                    Reject
                  </label>
                </div>
              </div>
            </div>
            {selectedStatus === "rejected" && (
              <div className="mb-3">
                <label className="form-label fw-semibold">
                  Reason for Rejection (Optional)
                </label>
                <textarea
                  className="form-control"
                  rows="3"
                  placeholder="Enter reason for rejection..."
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                ></textarea>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => onConfirm(selectedStatus, reason)}
            >
              Update Status
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};


export const ORDER_STEPS = [
  {
    key: "s2a_shipped",
    label: "Seller Preparing Package",
    message: "Your item has been dispatched from the seller.",
    time_key: "shipped_at",
    icon: <i class="bi bi-archive"></i>,
  },
  {
    key: "s2a_ready",
    label: "Ready For Collection",
    message: "Your item is ready for collection by the courier.",
    icon:<i class="bi bi-card-checklist"></i>
  },
  {
    key: "s2a_pickup",
    label: "Picked by Carrier",
    message: "The courier has picked up your package.",
    time_key: "pickup_at",
    icon: <i class="bi bi-truck"></i>,
  },
  {
    key: "s2a_in_transit",
    label: "In Transit",
    time_key: "in_transit_at",
    message: "Your package is on the way to the warehouse.",
    icon: <i class="bi bi-box"></i>,
  },
  {
    key: "s2a_out_for_delivery",
    label: "Out for Delivery",
    time_key: "out_for_delivery_at",
    message: "Your package is out for delivery to the warehouse.",
    icon: <i class="bi bi-truck-flatbed"></i>,
  },
  {
    key: "s2a_delivered",
    label: "Delivered to Warehouse",
    time_key: "delivered_at",
    message: "Package successfully received at the warehouse.",
    icon: <i class="bi bi-house-door"></i>,
  },

  {
    key: "a2b_shipped",
    label: "Shipped",
    time_key: "shipped_at",
    message: "Your item has been shipped from the warehouse.",
    icon: <i class="bi bi-archive"></i>,
  },
  {
    key: "a2b_ready",
    label: "Ready For Collection",
    message: "Your item is ready for collection by the courier.",
    icon:<i class="bi bi-card-checklist"></i>
  },
  {
    key: "a2b_pickup",
    label: "Picked by Carrier",
    time_key: "pickup_at",
    message: "The courier has picked up your package.",
    icon: <i class="bi bi-truck"></i>,
  },
  {
    key: "a2b_in_transit",
    label: "In Transit",
    time_key: "in_transit_at",
    message: "Your package is on the way to your address.",
    icon: <i class="bi bi-box"></i>,
  },
  {
    key: "a2b_out_for_delivery",
    label: "Out for Delivery",
    time_key: "out_for_delivery_at",
    message: "Your package is out for delivery.",
    icon: <i class="bi bi-truck-flatbed"></i>,
  },
  {
    key: "a2b_delivered",
    label: "Delivered",
    time_key: "delivered_at",
    message: "Package delivered successfully.",
    icon: <i class="bi bi-house-door"></i>,
  },
];

export const formattedDate = (date) =>
  new Date(date).toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });

  export const handleDownlaod = async (orderDetails,token,val=false) => {
    try {
      // const token = orderDetails?.admin_to_buyer?.tracking_token;

      const res = await print_order_detail(token,val);

      // console.log("ArrayBuffer:", res.data);

      const blob = new Blob([res.data], {
        type: "application/pdf",
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `shipment_invoice_${orderDetails?.id}.pdf`;
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed", error);
    }
  };